export default "__VITE_ASSET__DA_$daJP__"